import React, { useContext } from 'react';
import { BodyProps, CategoryAccordionProps } from '../../types';
import { AbsenceType } from '../../../../__generated__/graphql';
import { Accordion, Col, Row } from 'react-bootstrap';
import { CategoryAccordionBodyTitle } from './components/CategoryAccordionBodyTitle';
import CompensatoryTimeChart from '../../../../components/TimeSheet/CompensatoryTimeChart';
import { AllowanceListGroup } from './components/AllowanceListGroup';
import RequestAbsenceButtonSidebar from '../../../../components/RequestAbsenceButton';
import PeriodNav from '../../../../../../components/PeriodNav';
import {
  CategoryAccordionBodyContext,
  TContextProps,
} from './CategoryAccordionBodyContext';
import Loading from './components/Loading';
import { AbsencesContext } from '../../AbsencesContext';
import { PERIOD_TYPES } from './types';
import { createPeriod, getSummaryPeriod } from './helpers';
import { PureQueryOptions } from '@apollo/client';

type RequestAbsenceButtonProps = Pick<CategoryAccordionProps, 'categories'> & {
  categoryId: string;
  refetchQueries?: PureQueryOptions[];
};

const RequestAbsenceButton: React.FC<
  React.PropsWithChildren<RequestAbsenceButtonProps>
> = ({ categoryId, categories, refetchQueries }) => {
  return (
    <RequestAbsenceButtonSidebar
      categoryId={categoryId}
      categories={categories}
      variant="primary"
      block
      refetchQueries={refetchQueries}
    />
  );
};

const Body = ({
  summary,
  onPeriodChanged,
  periodType,
  category,
  hideRequestButton,
  categories,
  loading,
  refetchQueries,
}: BodyProps) => {
  const isNavVisible = !category.category.flair__Without_Balance__c;
  const isTitleVisible = !category.category.flair__Without_Balance__c;
  const isSummaryVisible =
    summary.hasYearlyBasedAccrualPolicy ||
    summary.isUnlimited ||
    !category.category.flair__Without_Balance__c;
  const { timeSheets } = useContext(AbsencesContext);
  const periods = PERIOD_TYPES.map((type) =>
    createPeriod(getSummaryPeriod(summary, type)),
  );

  const contextProps: { value: TContextProps } = {
    value: {
      periodType,
      category,
      isHourly: category.category.flair__Type__c === AbsenceType.Hourly,
    },
  };
  return (
    <CategoryAccordionBodyContext.Provider {...contextProps}>
      {isNavVisible && (
        <PeriodNav
          periods={periods}
          selectedIndex={PERIOD_TYPES.indexOf(periodType)}
          onPeriodChanged={(index) => onPeriodChanged(PERIOD_TYPES[index])}
        />
      )}

      {isTitleVisible && (
        <CategoryAccordionBodyTitle
          periodType={periodType}
          summary={summary}
          category={category}
        />
      )}

      <Accordion.Body className="pt-0">
        {!loading && summary ? (
          <>
            {isSummaryVisible && (
              <>
                <Row className="mb-3">
                  <Col>
                    {category.category.flair__Compensatory_Time__c ? (
                      <CompensatoryTimeChart timeSheets={timeSheets} />
                    ) : (
                      <AllowanceListGroup summary={summary} />
                    )}
                  </Col>
                </Row>
              </>
            )}

            {!hideRequestButton && periodType === 'current' && (
              <Row>
                <Col className={isTitleVisible ? '' : 'mt-3'}>
                  <RequestAbsenceButton
                    categoryId={category.Id}
                    categories={categories}
                    refetchQueries={refetchQueries}
                  />
                </Col>
              </Row>
            )}
          </>
        ) : (
          <Loading />
        )}
      </Accordion.Body>
    </CategoryAccordionBodyContext.Provider>
  );
};

export default Body;
